<!--
 * @Author: DQL
 * @Date: 2020-03-16 21:11:54
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:22:04
 * @Description: file content
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    :title="dlParams.parentMenuName ? '新增下级菜单' : '新增根菜单'"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="120px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          v-if="dlParams.parentMenuName"
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="上级菜单"
          >
            <span
              class="c-form__read"
            >
              {{ dlParams.parentMenuName }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="安全控制类别"
            prop="securityType"
          >
            <el-select
              v-model="fd.securityType"
              class="c-form__select"
              style="width: 100%;"
              placeholder="请选择"
            >
              <el-option
                v-for="item in securityType"
                :key="item.id"
                :label="item.text"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="所属业务系统"
            prop="appCode"
          >
            <el-select
              v-model="fd.appCode"
              class="c-form__select"
              style="width: 100%;"
              placeholder="请选择"
            >
              <el-option
                v-for="item in appList"
                :key="item.appCode"
                :label="item.appName"
                :value="item.appCode"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="菜单名称"
            prop="menuName"
          >
            <el-input
              v-model.trim="fd.menuName"
              class="c-form__input"
              placeholder="菜单名称"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="菜单类型"
            prop="menuType"
          >
            <el-radio-group
              v-model="fd.menuType"
              class="c-form__radio-group"
              @change="handleChangeMenuType"
            >
              <el-radio
                v-for="(value,key) in menuType"
                :key="key"
                :label="value.id"
              >
                {{ value.text }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <template v-if="fd.menuType && fd.menuType === '1'">
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="打开方式"
              prop="openType"
            >
              <el-radio-group
                v-model="fd.openType"
                class="c-form__radio-group"
              >
                <el-radio
                  v-for="(value,key) in menuOpenType"
                  :key="key"
                  :label="value.id"
                >
                  {{ value.text }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="菜单链接"
              prop="menuUrl"
            >
              <el-input
                v-model.trim="fd.menuUrl"
                class="c-form__input"
                placeholder="菜单链接"
              />
            </el-form-item>
          </el-col>
        </template>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="图标样式"
            prop="icon"
          >
            <el-input
              v-model="fd.icon"
              class="c-form__input"
              placeholder="图标样式"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="图标预览"
            prop="icon"
          >
            <span
              class="c-form__read"
            >
              <i :class="['u-text-lg', previewMenuIcon(fd.icon)]" />
            </span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';
import { addMenu, getAppList } from './menu.service';

export default {
  name: 'AddMenuDialog',
  props: {
    dlParams: {
      type: Object,
      required: true,
      default () {
        return {
          parentMenuCode: null,
          parentMenuName: null
        };
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        menuName: null,
        menuType: '1',
        icon: null,
        openType: '0',
        menuUrl: null,
        parentMenuCode: null,
        securityType: null, // 安全控制类别
        appCode: 'base'
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        menuName: [
          this.$validUtils.required('菜单名称'),
          this.$HMValidator.maxLength('菜单名称', 85)
        ],
        menuType: [
          this.$validUtils.required('菜单类型')
        ],
        icon: [
          this.$HMValidator.maxLength('图标样式', 85)
        ],
        openType: [
          this.$validUtils.required('打开方式')
        ],
        menuUrl: [
          this.$validUtils.required('菜单链接'),
          this.$HMValidator.maxLength('菜单链接', 1200)
        ],
        securityType: [
          this.$validUtils.required('安全控制类别')
        ],
        appCode: [
          this.$validUtils.required('所属业务系统')
        ]
      },
      /* 表单校验规则 End */
      appList: [] // 业务系统列表
    };
  },
  computed: {
    // 菜单类型
    menuType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.BASE_MENU_TYPE) {
        return enums.BASE_MENU_TYPE;
      }
      return {};
    },
    // 菜单打开方式
    menuOpenType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.BASE_MENU_OPEN_TYPE) {
        return enums.BASE_MENU_OPEN_TYPE;
      }
      return {};
    },
    // 安全控制类别
    securityType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.BASE_SECURITY_TYPE) {
        return enums.BASE_SECURITY_TYPE;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          const _fd = _this.handleFormatFd();
          addMenu(_fd)
            .then(rsp => {
              _this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', rsp.data.data);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 处理表单保存的数据
     * @param {*}
     * @return {*}
     */
    handleFormatFd () {
      const fd = _.clone(this.fd);
      if (fd.menuType === '0') {
        fd.openType = null;
        fd.menuUrl = null;
      }
      return fd;
    },
    /**
     * @description: 菜单类型切换，根据不同类型处理校验规则、数据等
     * @param {*}
     * @return {*}
     */
    handleChangeMenuType () {
      if (this.fd.menuType === '0') {
        if (this.$refs.fd) {
          this.$refs.fd.clearValidate();
        }
        this.fdRules.openType = [];
        this.fdRules.menuUrl = [];
      } else {
        this.fdRules.openType = [
          this.$validUtils.required('打开方式')
        ];
        this.fdRules.menuUrl = [
          this.$validUtils.required('菜单链接'),
          this.$HMValidator.maxLength('菜单链接', 1200)
        ];
      }
    },
    /**
     * @description: 菜单图标样式重组
     * @param {String} _icon, 图标样式
     * @return {*}
     */
    previewMenuIcon (_icon) {
      if (!_icon) {
        return;
      }
      // 例如传入 fa-cog
      if (_icon.indexOf('fa ') < 0 && _icon.indexOf('fa-') > -1) {
        return 'fa ' + _icon;
      }
      // 例如传入 ki-cog
      if (_icon.indexOf('ki ') < 0 && _icon.indexOf('ki-') > -1) {
        return 'kestrel-icon ' + _icon;
      }
      // 例如传入 icon-cog
      if (_icon.indexOf('iconfont ') < 0 && _icon.indexOf('icon-') > -1) {
        return 'iconfont ' + _icon;
      }
      return _icon;
    },
    /**
     * @description: 初始化加载业务系统下拉选项
     * @param {*}
     * @return {*}
     */
    initAppList () {
      const _this = this;
      _this.loading = true;
      getAppList()
        .then(rsp => {
          _this.appList = rsp.data;
        })
        .finally(() => {
          _this.loading = false;
        });
    }
  },
  created () {
    this.fd.parentMenuCode = this.dlParams.parentMenuCode;
    this.initAppList();
  }
};
</script>
